'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventManager = require('./util/EventManager');

var _EventManager2 = _interopRequireDefault(_EventManager);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* TODO: Add validation here :
*   - Validate type
*   - Maybe autoClose
*   - Maybe closeButton as well
* */
var POSITION = _config2.default.POSITION,
    TYPE = _config2.default.TYPE,
    ACTION = _config2.default.ACTION;


var defaultOptions = {
  type: TYPE.DEFAULT,
  autoClose: null,
  closeButton: null,
  hideProgressBar: null,
  position: null
};

var isContainerMounted = false;
var queue = [];
var toastId = 0;

function mergeOptions(options) {
  return Object.assign({}, defaultOptions, options, { toastId: ++toastId });
}

_EventManager2.default.on(ACTION.MOUNTED, function () {
  isContainerMounted = true;
  queue.forEach(function (item) {
    _EventManager2.default.emit(item.action, item.content, item.options);
  });
  queue = [];
});

var emitEvent = function emitEvent(content, options) {
  if (isContainerMounted) {
    _EventManager2.default.emit(ACTION.SHOW, content, options);
  } else {
    queue.push({ action: ACTION.SHOW, content: content, options: options });
  }

  return options.toastId;
};

exports.default = Object.assign(function (content, options) {
  return emitEvent(content, mergeOptions(options));
}, {
  success: function success(content, options) {
    return emitEvent(content, Object.assign(mergeOptions(options), { type: TYPE.SUCCESS }));
  },
  info: function info(content, options) {
    return emitEvent(content, Object.assign(mergeOptions(options), { type: TYPE.INFO }));
  },
  warn: function warn(content, options) {
    return emitEvent(content, Object.assign(mergeOptions(options), { type: TYPE.WARNING }));
  },
  error: function error(content, options) {
    return emitEvent(content, Object.assign(mergeOptions(options), { type: TYPE.ERROR }));
  },
  dismiss: function dismiss() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return _EventManager2.default.emit(ACTION.CLEAR, id);
  }
}, {
  POSITION: POSITION,
  TYPE: TYPE
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toastify/lib/toastify.js
 ** module id = 3543
 ** module chunks = 0
 **/